import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { LOCALE_STORAGE_KEY, DEFAULT_LOCALE, type AppLocale } from './app/core/i18n/locale.model';

/** Evita flash errado de tema antes do CSS carregar. */
function syncDocumentThemeClass(): void {
  const stored = localStorage.getItem('fisital_theme');
  const dark = stored !== 'light';
  document.documentElement.classList.toggle('dark', dark);
}

function syncDocumentLocale(): void {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  const locale: AppLocale =
    stored === 'pt-BR' || stored === 'en' || stored === 'es-ES' ? stored : DEFAULT_LOCALE;
  document.documentElement.lang = locale;
}

syncDocumentThemeClass();
syncDocumentLocale();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
